<template>
  <div>
    <introduction-banner />
    <div class="contents">
      <introduction-s-n-s />
      <introduction-benefit />
      <introdcution-method />
      <introduction-note />
    </div>
  </div>
</template>
<script>
import IntrodcutionMethod from './components/IntrodcutionMethod.vue'
import IntroductionBanner from './components/IntroductionBanner.vue'
import IntroductionBenefit from './components/IntroductionBenefit.vue'
import IntroductionNote from './components/IntroductionNote.vue'
import IntroductionSNS from './components/IntroductionSNS.vue'
export default {
  name: 'Introduction',
  components: { IntroductionBanner, IntroductionSNS, IntroductionNote, IntrodcutionMethod, IntroductionBenefit }
}
</script>
